module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c6bb07121b82bb055f9e7c3f85a16fd.png";